// Util
import { SortUtil } from '@/utils/sortUtil';

// Others
import config from '@/config/env-constants';
import _ from 'lodash';

export const DropDownItemsUtil = {

    getCompanyDisplay: (company) => {
        let status = company.isActive === true ? 'active' : 'inactive';
        return company.name + " (" + status + ") ";
    },

    getCompanyItem: company => {
        return {
            id: company.id,
            name: company.name,
            hasParentCompany: company.hasParentCompany,
            parentCompanyId: company.parentCompanyId
        }
    },

    retrieveCompanyItems: (companies) => {
        let companyItems = [];

        companyItems.push({
            value: { ...config.companyDefaultValue },
            text: ' - Please select - '
        });

        let companiesArr = Object.values(companies);
        companiesArr.forEach(company => {
            companyItems.push({
                value: {
                    id: company.id,
                    name: company.name,
                    hasParentCompany: company.hasParentCompany,
                    parentCompanyId: company.parentCompanyId
                },
                text: DropDownItemsUtil.getCompanyDisplay(company)
            });
        });

        companyItems = SortUtil.sortByAttr('text', companyItems);

        companyItems = _.uniq(companyItems, 'text');

        return companyItems;
    },

    retrieveLGUItems: (companies) => {
        let companyItems = [];

        companyItems.push({
            value: "",
            text: ' - Please select - '
        });

        let companiesArr = Object.values(companies);
        companiesArr.forEach(company => {
            if (company.isLgu) {
                companyItems.push({
                    value: {
                        id: company.id,
                        name: company.name
                    },
                    text: company.name
                });
            }
        });

        companyItems = SortUtil.sortByAttr('text', companyItems);

        companyItems = _.uniq(companyItems, 'text');

        return companyItems;
    },

    retrieveUsersItems: (users) => {
        let userItems = [];

        userItems.push({
            value: { ...config.userDefaultValue },
            text: ' - Please select - '
        });

        let usersArr = Object.values(users);
        usersArr.forEach(user => {
            let name = user.firstName + ' ' + user.lastName;
            userItems.push({
                value: {
                    id: user.id,
                    name: name,
                    companyId: user.companyId,
                    company: user.company
                },
                text: name
            });
        });

        userItems = SortUtil.sortByAttr('text', userItems);

        return userItems;
    },

    retrieveActiveUsersItems: (users) => {
        let userItems = [];

        userItems.push({
            value: { ...config.userDefaultValue },
            text: ' - Please select - '
        });

        let usersArr = Object.values(users);
        usersArr.forEach(user => {
            if (user.isActive) {
                let name = user.firstName + ' ' + user.lastName;
                userItems.push({
                    value: {
                        id: user.id,
                        name: name,
                        companyId: user.companyId,
                        company: user.company
                    },
                    text: name
                });
            }

        });

        userItems = SortUtil.sortByAttr('text', userItems);

        return userItems;
    },

    retrieveHubItems: (hubs) => {
        let hubItems = [];

        hubItems.push({
            value: { ...config.hubDefaultValue },
            text: ' - Please select - '
        });

        let hubsArr = Object.values(hubs);
        hubsArr.forEach(hub => {
            hubItems.push({
                value: {
                    id: hub.id,
                    name: hub.name
                },
                text: hub.name
            });
        });

        hubItems = SortUtil.sortByAttr('text', hubItems);

        return hubItems;
    },

    retrieveFormTypes: (formTypes) => {
        let formItems = [];

        formItems.push({
            value: null,
            text: ' - Please select - '
        });

        let formTypesArr = Object.values(formTypes);
        formTypesArr.forEach(formType => {
            formItems.push({
                value: formType,
                text: formType
            });
        });

        formItems = SortUtil.sortByAttr('text', formItems);

        return formItems;
    },

    retrieveRovingTemplates: (rovingTemplates) => {
        let rovingTemplateItems = [];

        rovingTemplateItems.push({
            value: null,
            text: ' - Please select - '
        });

        let rovingTemplateArr = Object.values(rovingTemplates);
        rovingTemplateArr.forEach(rovingTemplate => {
            rovingTemplateItems.push({
                value: rovingTemplate,
                text: rovingTemplate.name
            });
        });

        rovingTemplateItems = SortUtil.sortByAttr('text', rovingTemplateItems);

        return rovingTemplateItems;
    }
} 